import React from "react";
import { Navbar , Footer } from "../Rootelements/Homepagesubfiles";
import Firstcomponent from "../Rootelements/Servicessubfiles/Firstcomponent"
import Secondcomponet from "../Rootelements/Servicessubfiles/Secondcomponet";
import Thirdcomponent from "../Rootelements/Servicessubfiles/Thirdcomponent";
import Fourthcomponenttitle from "../Rootelements/Servicessubfiles/Fourthcomponenttitle";
import Fourthcomponent from "../Rootelements/Servicessubfiles/Fourthcomponent";
import Zerothcomponent from "../Rootelements/Servicessubfiles/Zerothcomponent";

function Services(){
    return(
        <div>
        <Navbar/>
        <Zerothcomponent />
        <Firstcomponent />
        <Secondcomponet />
        <Thirdcomponent />
        <Footer/>
        </div>
    )
};

export default Services;